import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5",
    d: "M3.334 10c-.622 0-.932 0-1.177-.102a1.33 1.33 0 0 1-.722-.721C1.333 8.932 1.333 8.62 1.333 8V3.467c0-.747 0-1.12.146-1.406.128-.25.332-.455.583-.582.285-.146.658-.146 1.405-.146H8c.621 0 .932 0 1.177.102.327.135.586.395.722.721.101.245.101.556.101 1.177M8.133 14.667h4.4c.747 0 1.12 0 1.406-.146.25-.128.455-.332.582-.582.146-.286.146-.659.146-1.406v-4.4c0-.746 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583C13.654 6 13.28 6 12.534 6h-4.4c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.583.583C6 7.013 6 7.387 6 8.133v4.4c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.406.146"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0h16v16H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }